<script>
import options from './ColorPreview.options'
export default options
</script>

<template>
  <article class="kb-color-preview-container">
    <h1>Farve tester</h1>

    <textarea id="cssoutput" v-model="string" disabled> </textarea>

    <template v-for="(value, color, index) in config" :key="index">
      <div class="kb-color-preview">
        <label
          >{{ color }}
          <div
            class="kb-color-preview__previewer"
            :style="{ 'background-color': value }"
          ></div
        ></label>
        <input v-model="config[color]" />
      </div>
    </template>

    <div class="kb-color-preview-buttons">
      <button class="kb-button kb-button--full-color-spot" @click="insert">
        Test
      </button>
      <button class="kb-button kb-button" @click="remove">Fjern</button>
      <button class="kb-button kb-button" @click="copy">
        Kopiér til udklipsholder
      </button>
    </div>
  </article>
</template>
